module.exports = __webpack_public_path__ + "img/48.3e27268c.png";